import { Button } from '~/primitives/button';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogFooter,
    DialogClose,
    DialogTitle,
    DialogDescription,
} from '~/primitives/dialog';
import { ModalProps } from '~/util';

interface ConfirmModalProps extends ModalProps {
    onConfirm: () => void;
    text?: string;
    title?: string;
    buttonText?: string;
    buttonVariant?: 'default' | 'destructive';
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    open,
    onOpenChange,
    onConfirm,
    title = 'Confirm',
    text = 'Are you sure you want to perform this action?',
    buttonText = 'Confirm',
    buttonVariant = 'default',
}) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{text}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <DialogClose asChild>
                        <Button variant="secondary">Cancel</Button>
                    </DialogClose>
                    <DialogClose asChild>
                        <Button onClick={onConfirm} variant={buttonVariant}>
                            {buttonText}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default ConfirmModal;
